import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from 'src/app/layout/layout.component';
import { CamTabLayoutComponent } from './components/cam-tab-layout/cam-tab-layout.component';
import { CompanyDetailComponent } from './components/company-detail/company-detail.component';
import { CompanyManagementComponent } from './components/company-management/company-management.component';
import { TravelerManagmentComponent } from './components/traveler-managment/traveler-managment.component';
import { DepartmentComponent } from './components/department/department.component';
import { TravelerDetailsComponent } from './components/traveler-details/traveler-details.component';
import { PersonalInfoFormComponent } from './components/personal-info-form/personal-info-form.component';
import { ContactDetailsFormComponent } from './components/contact-details-form/contact-details-form.component';
import { DependentsFormComponent } from './components/dependents-form/dependents-form.component';
import { SavedDependentsComponent } from './components/saved-dependents/saved-dependents.component';
import { DocumentInfoFormComponent } from './components/document-info-form/document-info-form.component';
import { EmployeeDetailsFormComponent } from './components/employee-details-form/employee-details-form.component';
import { SavedCardsComponent } from './components/saved-cards/saved-cards.component';
import { PreferencesFormComponent } from './components/preferences-form/preferences-form.component';
import { EmergerencyContectFormComponent } from './components/emergerency-contect-form/emergerency-contect-form.component';
import { DesignationComponent } from './components/designation/designation.component';
import { EmployeegradeComponent } from './components/employeegrade/employeegrade.component';
import { TravelCategoryComponent } from './components/travel-category/travel-category.component';
import { PreDefinedReasonsComponent } from './components/pre-defined-reasons/pre-defined-reasons.component';
import { BranchInfoComponent } from './components/branch-info/branch-info.component';
import { CostCenterOverviewComponent } from './components/cost-center-overview/cost-center-overview.component';
import { ProjectDetailsComponent } from './components/project-details/project-details.component';
import { CorporateCardsComponent } from './components/corporate-cards/corporate-cards.component';
import { BusinessUnitOverviewComponent } from './components/business-unit-overview/business-unit-overview.component';
import { CompanySettingsComponent } from './components/company-settings/company-settings.component';
import { ApprovalManagementComponent } from './components/approval-management/approval-management.component';
import { ApprovalflowFormComponent } from './components/approvalflow-form/approvalflow-form.component';
import { ApproversComponent } from './components/approvers/approvers.component';
import { ApprovalListingComponent } from './components/approval-listing/approval-listing.component';
import { MultiTravelerManagmentComponent } from './components/multi-traveler-managment/multi-traveler-managment.component';
import { PolicyCriteriaComponent } from './components/policy-criteria/policy-criteria.component';
import { PolicyConfigurationComponent } from './components/policy-configuration/policy-configuration.component';
import { PolicyManagementComponent } from './components/policy-management/policy-management.component';
import { WorkflowsettingFormComponent } from './components/workflowsetting-form/workflowsetting-form.component';
import { ReportingManagerTravelerComponent } from './components/reporting-manager-traveler/reporting-manager-traveler.component';
import { roleGuard } from '../../shared/guards/role.guard';
import { EnableCompanyLoginComponent } from './components/enable-company-login/enable-company-login.component';
import { ChangeEmailDomainComponent } from './components/change-email-domain/change-email-domain.component';
import { DependentInformationFormComponent } from './components/dependent-information-form/dependent-information-form.component';
import { FamilyMemberManagementComponent } from './components/family-member-management/family-member-management.component';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { NewTravelerFormComponent } from './components/new-traveler-form/new-traveler-form.component';
import { ChangeRuleComponent } from './components/change-rule/change-rule.component';
import { DelegationComponent } from './components/delegation/delegation.component';
import { LoggedinDevicesComponent } from './components/loggedin-devices/loggedin-devices.component';


const routes: Routes = [
  {

    path: '',
    component: LayoutComponent,
    children: [
      {
        path: '', component: CamTabLayoutComponent,
        children: [

          {
            path: 'company-management', component: CompanyManagementComponent,
            children: [
              { path: 'company-details', component: CompanyDetailComponent, data: { breadcrumb: 'b2b.managecompany.cdcompanydetails' } },
              { path: 'branch-information', component: BranchInfoComponent, data: { breadcrumb: 'b2b.managecompany.bibranchinformation' } },
              { path: 'cost-center-overview', component: CostCenterOverviewComponent, data: { breadcrumb: 'b2b.managecompany.bicostcenteroverview' } },
              { path: 'project-details', component: ProjectDetailsComponent, data: { breadcrumb: 'Project Details' } },
              { path: 'corporate-cards', component: CorporateCardsComponent, data: { breadcrumb: 'b2b.managecompany.cccorporatecards' } },
              { path: 'business-unit-overview', component: BusinessUnitOverviewComponent, data: { breadcrumb: 'Business Unit Overview' } }
            ],
            canActivate: [roleGuard],
            data: { breadcrumb: 'b2b.managecompany.companymanagement' }
          },
          {
            path: 'traveler-profile', component: CompanyManagementComponent,
            children: [
              { path: 'department', component: DepartmentComponent, data: { breadcrumb: 'b2b.managecompany.department' } },
              { path: 'designation', component: DesignationComponent, data: { breadcrumb: 'b2b.managecompany.tpdesignation' } },
              { path: 'employeegrade', component: EmployeegradeComponent, data: { breadcrumb: 'b2b.managecompany.ccemployeegrade' } },
              { path: 'travel-category', component: TravelCategoryComponent, data: { breadcrumb: 'b2b.managecompany.tptravelcategory' } },
              { path: 'pre-defined-reasons', component: PreDefinedReasonsComponent, data: { breadcrumb: 'b2b.managecompany.tppredefinereasons' } },
            ],
            data: { breadcrumb: 'b2b.managecompany.companymanagement' }
          },
          {
            path: 'traveler-management', component: TravelerManagmentComponent,
            data: { breadcrumb: 'b2b.header.travelermanagement' }
          },
          {
            path: 'traveler-details', component: TravelerDetailsComponent,
            children: [
              { path: 'personal-info', component: PersonalInfoFormComponent, data: { breadcrumb: 'b2b.managetraveler.personalinfo' } },
              { path: 'personal-info/:userId/:guid', component: PersonalInfoFormComponent, data: { breadcrumb: 'b2b.managetraveler.personalinfo' } },
              { path: 'contact-detail', component: ContactDetailsFormComponent, data: { breadcrumb: 'b2b.managetraveler.contactdetails' } },
              { path: 'document-info', component: DocumentInfoFormComponent, data: { breadcrumb: 'b2b.managetraveler.docinfo' } },
              { path: 'employee-details', component: EmployeeDetailsFormComponent, data: { breadcrumb: 'b2b.managetraveler.employmentdetails' } },
              { path: 'saved-cards', component: SavedCardsComponent, data: { breadcrumb: 'b2b.managetraveler.savedcards' } },
              { path: 'preferences', component: PreferencesFormComponent, data: { breadcrumb: 'b2b.managetraveler.preferences' } },
              { path: 'emergency-contact', component: EmergerencyContectFormComponent, data: { breadcrumb: 'Emergency contact details' } },
              { path: 'change-password', component: ChangePasswordComponent, data: { breadcrumb: 'b2b.managetraveler.changepasswords' } },
              { path: 'add-new-traveler', component: NewTravelerFormComponent },

              { path: '**', redirectTo: '' }
            ],
            data: { breadcrumb: 'b2b.header.travelermanagement' }
          },
          {
            path: 'other-misc-func', component: CompanyManagementComponent,
            children: [
              { path: 'company-setting', component: CompanySettingsComponent, data: { breadcrumb: 'b2b.managecompany.omfcompanysettings' } },
              { path: 'multi-travel-management', component: MultiTravelerManagmentComponent, data: { breadcrumb: 'b2b.managecompany.omfmultitrevelerheading' } },
              { path: 'enable-company-login', component: EnableCompanyLoginComponent, data: { breadcrumb: 'b2b.managecompany.omfenablecompanylogin' } },
              { path: 'change-email-domain', component: ChangeEmailDomainComponent, data: { breadcrumb: 'b2b.managecompany.omfchangeemaildomain' } },
            ],
            data: { breadcrumb: 'b2b.header.companymanagement' }
          },

          {
            path: 'saved-dependents', component: SavedDependentsComponent,
            children: [
              {
                path: 'dependent-form', component: DependentsFormComponent, data: { breadcrumb: 'b2b.managetraveler.dependentdetails' },
              },
              {
                path: 'dependent-information-form',
                component: DependentInformationFormComponent
              },
            ],
            data: { breadcrumb: 'b2b.managetraveler.saveddependents' }
          },
          {
            path: 'manage-delegation-setting', component: TravelerDetailsComponent,
            children: [
              { path: 'reporting-manager', component: ReportingManagerTravelerComponent, data: { breadcrumb: 'b2b.managetraveler.managername' } },
              { path: 'approvers', component: ApproversComponent, data: { breadcrumb: 'b2b.managetraveler.approvers' } },
              { path: 'delegation', component: DelegationComponent, data: { breadcrumb: 'b2b.managetraveler.delegation' } }
            ],
          },
          {
            path: 'manage-devices', component: TravelerDetailsComponent,
            children: [
              { path: 'loggedin-devices', component: LoggedinDevicesComponent, data: { breadcrumb: 'Logged in Devices' } },
            ],
          },
          {
            path: 'approval-management', component: ApprovalManagementComponent,
            children: [
              { path: '', redirectTo: 'approval-listing', pathMatch: 'full' },
              { path: 'workflow-setting', component: WorkflowsettingFormComponent, data: { breadcrumb: 'b2b.manageapproval.workflowsettings' } },
              { path: 'workflow-setting/:id', component: WorkflowsettingFormComponent, data: { breadcrumb: 'b2b.manageapproval.workflowsettings' } },
              { path: 'approvalflow-form', component: ApprovalflowFormComponent, data: { breadcrumb: 'Approval Flow Form' } },
              { path: 'approvers', component: ApproversComponent, data: { breadcrumb: 'b2b.manageapproval.approvers' } },
              { path: 'approval-listing', component: ApprovalListingComponent, data: { breadcrumb: 'Approval Listing' } },
            ],
            canActivate: [roleGuard],
            data: { breadcrumb: 'b2b.header.approvalmanagement' }
          },
          {
            path: 'policy-management', component: PolicyManagementComponent,
            children: [
              { path: 'policy-configuration', component: PolicyConfigurationComponent, data: { breadcrumb: 'policy configuration' } },
              { path: 'policy-criteria', component: PolicyCriteriaComponent, data: { breadcrumb: 'b2b.managepolicy.pctitle' } },
              { path: 'change-rule', component: ChangeRuleComponent, data: { breadcrumb: 'b2b.managepolicy.changerules' } },
            ],
            canActivate: [roleGuard],
            data: { breadcrumb: 'b2b.header.policymanagement' }
          },
          {
            path: 'family-member-management', component: FamilyMemberManagementComponent,
            data: { breadcrumb: 'b2b.header.familymembermanagement' }
          },

        ],
        data: { breadcrumb: 'b2b.header.accountmanagement' }
      }
    ],
    data: { breadcrumb: 'Home' },
  }
];


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CAMRoutingModule { }
